<template>
    <div class="o-container -container-max">
        <div class="o-filter__accordion" :class="{'is-open': isOpen}">
            <button @click="isOpen=!isOpen" class="o-filter__accordion__toggler">
                <span class="o-filter__accordion__toggler__text">
                    Filtrer les résultats
                </span>
                <span class="o-filter__accordion__toggler__icon">
                    <svg aria-hidden="true" focusable="false" class="o-ico">
                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#filter"></use>
                    </svg>
                </span>
            </button>
            <div class="o-filter__accordion__content">
                <div class="o-filter__accordion__content__inner">
                    <div class="o-filter u-color-1 u-bg-color-1-lightest">
                        <div class="o-form__wrap">
                            <form class="o-form" @submit.prevent>
                                <div class="o-spacer-sm"></div>
                                <div class="o-flex">
                                    <button v-for="letter in alphabet" class="-text-bold" :class="{'is-active': selectedLetter==letter}" @click.prevent="toggleLetter(letter)">{{ letter }}</button>
                                </div>
                                <div class="o-spacer-line"></div>
                                <div class="o-subtitle">
                                    Type d’auteur.e.s
                                </div>
                                <div class="o-spacer-sm"></div>
                                <div class="o-flex -flex-gap">
                                    <div class="o-flex__item">
                                        <div class="o-toggle">
                                            <div class="o-toggle__input__wrap">
                                                <input class="o-toggle__input" type="checkbox" id="toggle-1" v-model="isJeunesse" value="1">
                                                <div class="o-toggle__toggler"></div>
                                            </div>
                                            <label class="o-toggle__label" for="toggle-1">
                                                <span class="o-toggle__label__text">
                                                    <svg aria-hidden="true" focusable="false" class="o-ico">
                                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#puzzle"></use>
                                                    </svg>
                                                    Jeunesse
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="o-flex__item">
                                        <div class="o-toggle">
                                            <div class="o-toggle__input__wrap">
                                                <input class="o-toggle__input" type="checkbox" id="toggle-2" v-model="isMauricie" value="1">
                                                <div class="o-toggle__toggler"></div>
                                            </div>
                                            <label class="o-toggle__label" for="toggle-2">
                                                <span class="o-toggle__label__text">
                                                    <svg aria-hidden="true" focusable="false" class="o-ico">
                                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#region"></use>
                                                    </svg>
                                                    Auteur.e.s de la région
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="o-flex__item">
                                        <div class="o-toggle">
                                            <div class="o-toggle__input__wrap">
                                                <input class="o-toggle__input" type="checkbox" id="toggle-3" v-model="isIllustrateur" value="1">
                                                <div class="o-toggle__toggler"></div>
                                            </div>
                                            <label class="o-toggle__label" for="toggle-3">
                                                <span class="o-toggle__label__text">
                                                    <svg aria-hidden="true" focusable="false" class="o-ico">
                                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#paint"></use>
                                                    </svg>
                                                    Illustrateur.ice.s
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="o-spacer-line"></div>
                                <div class="o-subtitle">
                                    Recherchez
                                </div>
                                <div class="o-spacer-sm"></div>
                                <div class="o-flex -flex-gap -flex-space-between">
                                    <div class="o-flex__item">
                                        <div class="o-flex -flex-gap-xs -flex-wrap o-form-group">
                                            <div class="o-flex__item">
                                                <div class="o-form-group__item">
                                                    <label class="o-label sr-only" for="recherche">Recherche</label>
                                                    <input  @keyup.enter.prevent="" @keydown.enter.prevent="" class="o-input -input-has-icon" type="text" id="prenom" v-model="searchInput" placeholder="Mots-clés ex. Roman">
                                                    <svg aria-hidden="true" focusable="false" class="o-ico o-input__icon">
                                                        <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#search"></use>
                                                    </svg>
                                                </div>
                                            </div>
                                            <div class="o-flex__item">
                                                <div class="o-form-group__item">
                                                    <label class="o-label sr-only" for="date">Date</label>
                                                    <div class="o-select__wrap">
                                                        <select class="o-select" id="date" v-model="selectedDate">
                                                            <option value="" disabled selected>Date</option>
                                                            <option v-for="date in dates" :value="date.date">{{ date.label }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="o-flex__item -flex-align-self-end">
                                        <button @click.prevent="reset()" class="o-form__button__reset">
                                            Réinitialiser
                                        </button>
                                    </div>
                                </div>
                                <div class="o-spacer-line"></div>
                                <div class="o-flex -flex-wrap -flex-gap-xxs">
                                    <div v-for="tag in tags" class="o-flex__item">
                                        <div class="o-filter__active">
                                            <span class="o-filter__active__text">
                                                {{ tag.label }}
                                            </span>
                                            <button @click.prevent="removeTag(tag)" class="o-filter__active__close">
                                                <svg aria-hidden="true" focusable="false" class="o-ico">
                                                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#close"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from 'debounce';

export default {
    name: 'AuteursSearch',
    props: {
        dates: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isOpen: false,
            selectedLetter: '',
            selectedDate: '',
            isJeunesse: false,
            isMauricie: false,
            isIllustrateur: false,
            searchInput: '',
            search: '',
            auteurs: [],
            loading: false,
            controller: new AbortController()
        }
    },
    mounted() {
        const currentUrl = new URL(window.location.href);
        const query = currentUrl.search;
        const urlParams = new URLSearchParams(query);
        if (urlParams.has('jeunesse')) {
            this.isJeunesse = true;
        }
        if (urlParams.has('mauricie')) {
            this.isMauricie = true;
        }
        if (urlParams.has('illustrateur')) {
            this.isIllustrateur = true;
        }
        if (urlParams.has('date')) {
            this.selectedDate = urlParams.get('date');
        }
        if (urlParams.has('search')) {
            this.searchInput = urlParams.get('search');
        }
        if (urlParams.has('letter')) {
            this.selectedLetter = urlParams.get('letter');
        }

        this.$watch('isJeunesse',() => {
            this.updateUrl();
        });
        this.$watch('isMauricie', () => {
            this.updateUrl();
        });
        this.$watch('isIllustrateur', () => {
            this.updateUrl();
        });
        this.$watch('selectedDate', () => {
            this.updateUrl();
        });
        this.$watch('searchInput', () => {
            this.searchTyping();
        });
        this.$watch('selectedLetter', () => {
            this.updateUrl();
        });

        document.querySelector('.js-next-page').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            let target = e.target;
            if (target.tagName !== 'A') {
                target = target.parentNode;
            }
            window.history.pushState({}, '', target.href);
            this.loadContent(target.href, true);
        }, true);
    },
    computed: {
        alphabet() {
            return 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        },
        tags() {
            let tags = [];

            if (this.isJeunesse) {
                tags.push({'label': 'Jeunesse', 'variable': 'isJeunesse'});
            }
            if (this.isMauricie) {
                tags.push({'label': 'Auteur.e.s de la région', 'variable': 'isMauricie'});
            }
            if (this.isIllustrateur) {
                tags.push({'label': 'Illustrateur.ice.s', 'variable': 'isIllustrateur'});
            }
            if (this.selectedDate) {
                let label = this.dates.find(date => date.date === this.selectedDate).label;
                tags.push({'label': label, 'variable': 'selectedDate'});
            }
            if (this.selectedLetter) {
                tags.push({'label': this.selectedLetter, 'variable': 'selectedLetter'});
            }

            return tags;
        }
    },
    methods: {
        toggleLetter(letter) {
            this.selectedLetter = this.selectedLetter === letter ? '' : letter;
        },
        removeTag(tag) {
            this[tag.variable] = this[tag.variable]===true ? false : '';
        },
        reset() {
            this.selectedLetter = '';
            this.selectedDate = '';
            this.isJeunesse = false;
            this.isMauricie = false;
            this.isIllustrateur = false;
            this.searchInput = '';
            this.updateUrl();
        },
        searchTyping: debounce(function(e) {
            this.updateUrl();
        }, 500),
        updateUrl() {
            const currentUrl = new URL(window.location.href);
            let pathName = currentUrl.pathname;
            url = pathName.replace(/\/page\/\d+/, '');
            let searchParams = new URLSearchParams(currentUrl.search);
            if (this.isJeunesse) {
                searchParams.set('jeunesse', 1);
            } else {
                searchParams.delete('jeunesse');
            }
            if (this.isMauricie) {
                searchParams.set('mauricie', 1);
            } else {
                searchParams.delete('mauricie');
            }
            if (this.isIllustrateur) {
                searchParams.set('illustrateur', 1);
            } else {
                searchParams.delete('illustrateur');
            }
            if (this.selectedDate) {
                searchParams.set('date', this.selectedDate);
            } else {
                searchParams.delete('date');
            }
            if (this.searchInput) {
                searchParams.set('search', this.searchInput);
            } else {
                searchParams.delete('search');
            }
            if (this.selectedLetter) {
                searchParams.set('letter', this.selectedLetter);
            } else {
                searchParams.delete('letter');
            }
            url += '?' + searchParams.toString();
            window.history.pushState({}, '', url);
            this.loadContent(url);
        },
        loadContent(url, append = false) {
            this.loading = true;
            this.controller.abort();
            this.controller = new AbortController();

            fetch(url, {
                signal: this.controller.signal
            })
            .then(response => response.text())
            .then(data => {
                let parser = new DOMParser();

                let html = parser.parseFromString(data, 'text/html');
                let results = html.querySelector('.js-results');
                if (results.querySelectorAll('div').length === 0) {
                    document.querySelector('.js-no-results').style.display = null;
                    document.querySelector('.js-results').style.display = 'none';
                    document.querySelector('.js-next-page').style.display = 'none';
                } else {
                    document.querySelector('.js-no-results').style.display = 'none';
                    document.querySelector('.js-results').style.display = null;
                    if (append) {
                        document.querySelector('.js-results').insertAdjacentHTML('beforeend', results.innerHTML);
                    } else {
                        document.querySelector('.js-results').innerHTML = results.innerHTML;
                    }

                    let nextPage = html.querySelector('.js-next-page');
                    if (nextPage && nextPage.href.length && nextPage.href !== window.location.href) {
                        document.querySelector('.js-next-page').href = nextPage.href;
                        document.querySelector('.js-next-page').style.display = null;
                    } else {
                        document.querySelector('.js-next-page').style.display = 'none';
                    }
                }
                //this.modular.call('update', document.querySelector('.js-results'), 'app');
                this.emitter.emit('callCarnetContent');
                this.loading = false;
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    console.log('Fetch aborted');
                } else {
                    console.error('Error:', error);
                }
            });
        }
    }
}
</script>